const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgAvatarStandard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30.6666 31.625V29.7083C30.6666 28.6917 30.2627 27.7166 29.5438 26.9978C28.8249 26.2789 27.8499 25.875 26.8333 25.875H19.1666C18.1499 25.875 17.1749 26.2789 16.456 26.9978C15.7371 27.7166 15.3333 28.6917 15.3333 29.7083V31.625M26.8333 18.2083C26.8333 20.3254 25.117 22.0417 22.9999 22.0417C20.8828 22.0417 19.1666 20.3254 19.1666 18.2083C19.1666 16.0912 20.8828 14.375 22.9999 14.375C25.117 14.375 26.8333 16.0912 26.8333 18.2083Z",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 22.5,
    stroke: "transparent"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarStandard);
export default __webpack_public_path__ + "static/media/Avatar_standard.4db0a7f2342105d5fed30bf904de5d44.svg";
export { ForwardRef as ReactComponent };